// https://github.com/diegohaz/arc/wiki/Atomic-Design
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { hasFailed } from 'redux-saga-thunk';
import { Flex } from 'rebass';

import { resourceDetailReadRequest,
  setReservationId,
  addReservation,
  addMarketSettings,
  changeLanguage,
  setReservationStatus,
  toggleAllPassengersExpanded } from 'store/actions';
import { fromReservation } from 'store/selectors';

import { T } from 'containers';
import { AppText } from 'domain/appText';

import { Spinner } from 'shared-components';

import ReservationFailedToLoad from '../ReservationFailedToLoad';

const StatusWrapper = styled(Flex)`
  height: 50vh;
`;

const RESOURCE = 'reservations';
const LOADING = 'loading';

const queryStrings = new URLSearchParams(window.location.search);
const EXPANDED = queryStrings.get('expanded');

const oneThunkFailed = state => [
  'reservationsDetailRead',
  'settingsDetailRead',
  'cmsDetailRead',
].reduce((agg, curr) => agg || hasFailed(state, curr), false);

const mapStateToProps = state => ({
  failed: oneThunkFailed(state) || fromReservation.hasReservationFailed(state),
  done: fromReservation.getDepartures(state).length > 0 && !fromReservation.hasReservationFailed(state),
});

const fetchSalesOwnerSettings = (dispatch, id, language, travelDate) =>
  dispatch(resourceDetailReadRequest('settings', `${id}/${language}?travelDate=${travelDate}`))
    .catch(() => {})
    .then((settings) => {
      dispatch(addMarketSettings(settings, language));
    });

const fetchReservation = (dispatch, id, language) =>
  dispatch(resourceDetailReadRequest(RESOURCE, id))
    .catch(() => {})
    .then((reservation) => {
      const reservationStatus = reservation && reservation.reservationStatus.toLowerCase();
      dispatch(setReservationStatus(reservationStatus));
      if (reservation) {
        Promise.resolve()
          .then(() => dispatch(addReservation(reservation)));
      }
      if (reservation && reservationStatus === 'confirmed') {
        Promise.resolve()
          .then(() => {
            const latestDeparture = reservation.departures.reduce((a, b) => a.departureDate > b.departureDate ? a : b);
            const travelDate = latestDeparture.departureDate;
            fetchSalesOwnerSettings(dispatch, reservation.salesOwnerId, language ? language.substring(0, 2) : reservation.languageCode.includes('nb-') ? 'no' : reservation.languageCode.substring(0, 2), travelDate) // eslint-disable-line
          })

          .then(() => {
            if (EXPANDED) {
              dispatch(toggleAllPassengersExpanded());
            }
          })
          .then(() => document.body.classList.remove(LOADING))
        ;
      } else {
        Promise.resolve()
          .then(() => dispatch(changeLanguage(language || (reservation && reservation.languageCode) || 'en-GB')))
          .then(() => document.body.classList.remove(LOADING))
        ;
      }
    });

const mapDispatchToProps = (dispatch, { id }) => ({
  loadReservation: (language) => {
    dispatch(setReservationId(id));
    fetchReservation(dispatch, id, language);
  },
});

class ReservationLoader extends React.Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    loadReservation: PropTypes.func.isRequired,
    component: PropTypes.any.isRequired,
    failed: PropTypes.bool,
    done: PropTypes.bool,
    lang: PropTypes.string,
    text: PropTypes.object,
  }
  state = {
    isTriggered: false,
  };
  componentWillMount() {
    const language = this.props.lang;
    this.props.loadReservation(language);
    this.setState(() => ({ isTriggered: true }));
  }
  render() {
    const { done, failed, component } = this.props;
    if (done) {
      return component;
    } else if (failed) {
      return (
        <T
          text={[
            AppText.ReservationFailedToLoad,
            AppText.MarketHelpDeskEmail,
            AppText.MarketHelpDeskLink,
            AppText.MarketHelpDeskLinkText,
          ]}
          render={([
            reservationFailedToLoad,
            marketHelpDeskEmail,
            marketHelpDeskLink,
            marketHelpDeskLinkText,
            ]) => (
              <ReservationFailedToLoad
                reservationFailedToLoad={reservationFailedToLoad}
                marketHelpDeskEmail={marketHelpDeskEmail}
                marketHelpDeskLink={marketHelpDeskLink}
                marketHelpDeskLinkText={marketHelpDeskLinkText}
              />
          )}
        />
      );
    }
    return <StatusWrapper align="center"><Spinner size={3} /></StatusWrapper>;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReservationLoader);



// WEBPACK FOOTER //
// ./src/loaders/ReservationLoader/index.js